
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-teal-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3 mb-4">
            <img 
              src="https://static.readdy.ai/image/cb419a93222bfd6610832c3481bbaa16/c3691d6cbb39295a29c34cdb741ff2aa.png" 
              alt="CleanerConnect Logo" 
              className="w-20 h-20 object-contain"
            />
            <span className="text-2xl font-bold">CleanerConnect</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 text-sm">
            <a href="#privacy" className="hover:text-teal-300 transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#terms" className="hover:text-teal-300 transition-colors cursor-pointer">
              Terms of Service
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:text-teal-300 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>

          <div className="text-sm text-teal-200">
            © {currentYear} CleanerConnect. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
